import React from 'react';
import { MotifButton } from '@ey-xd/motif-react';

export interface ActionItem {
  label: string | React.ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

interface ActionsProps {
  items: ActionItem[];
  align?: 'left' | 'right';
  gap?: number;
}

const Actions: React.FC<ActionsProps> = ({ items, align = 'right', gap = 8 }) => {
  return (
    <div style={{ display: 'flex', justifyContent: align === 'right' ? 'flex-end' : 'flex-start', gap }}>
      {items.map((item, idx) => (
        <MotifButton key={idx} variant={item.variant || 'secondary'} size={item.size || 'medium'} disabled={item.disabled} onClick={item.onClick} style={{ minWidth: item.size === 'small' ? 'auto' : undefined }}>
          {item.label}
        </MotifButton>
      ))}
    </div>
  );
};

export default Actions;
